var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:school"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5001 8.33335H15.8334V3.33335H16.6667V1.66669H3.33341V3.33335H4.16675V8.33335H2.50008C2.27907 8.33335 2.06711 8.42115 1.91083 8.57743C1.75455 8.73371 1.66675 8.94567 1.66675 9.16669V16.6667H18.3334V9.16669C18.3334 8.94567 18.2456 8.73371 18.0893 8.57743C17.9331 8.42115 17.7211 8.33335 17.5001 8.33335ZM11.6667 15V11.6667H8.33341V15H5.83341V3.33335H14.1667V15H11.6667Z",
    fill: "#9599A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 5H9.16667V6.66667H7.5V5ZM10.8333 5H12.5V6.66667H10.8333V5ZM7.5 8.33333H9.16667V10H7.5V8.33333ZM10.8333 8.33333H12.5V10H10.8333V8.33333Z",
    fill: "#9599A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducenter);
export default __webpack_public_path__ + "static/media/educenter.7235385ef9a76cb954d91585ca64b63f.svg";
export { ForwardRef as ReactComponent };